// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._dMLJJGFA4JEkuCZT9jl {
  height: 12px;
  width: 12px;
  fill: var(--neutral500);
}

.xUSJ2cx8poGB2k381_5U path {
  fill: var(--primary600);
}

.fHlUiIHgeQtHeWPM4jQJ {
  cursor: pointer;
  height: 10px;
  width: 10px;
}

.fHlUiIHgeQtHeWPM4jQJ path {
  fill: var(--neutral500);
}
`, "",{"version":3,"sources":["webpack://./src/shared/admin/components/SearchInput/SearchInput.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".search-icon {\n  height: 12px;\n  width: 12px;\n  fill: var(--neutral500);\n}\n\n.search-icon-active path {\n  fill: var(--primary600);\n}\n\n.reset-icon {\n  cursor: pointer;\n  height: 10px;\n  width: 10px;\n}\n\n.reset-icon path {\n  fill: var(--neutral500);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-icon": `_dMLJJGFA4JEkuCZT9jl`,
	"search-icon-active": `xUSJ2cx8poGB2k381_5U`,
	"reset-icon": `fHlUiIHgeQtHeWPM4jQJ`
};
export default ___CSS_LOADER_EXPORT___;
